import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CommissionDashboard from './Commission';
import PlayerCommissionDashboard from './playerCommissionDashboard';
import { format, subDays } from 'date-fns';

const CommissionTab = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Overall" />
                    <Tab label="Player specific" />
                </Tabs>
            </Box>
            {/* Tab content */}
            <TabPanel value={value} index={0}>
                <Box sx={{ p: 3 }}>
                    <CommissionDashboard  />
                </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Box sx={{ p: 3 }}>
                    <PlayerCommissionDashboard />
                </Box>
            </TabPanel>
        </Box>
    );
};

// TabPanel component to handle tab content visibility
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default CommissionTab;